export default "__VITE_ASSET__DlLH5$re__"